module.exports = __webpack_public_path__ + "651bcb5890d1773b79b2a11e0ca8d0a7.png";